class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
          
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
        setTimeout(function() { 
            let resultArray = [];
            async function fetchProductData(productId) {
            const response = await fetch(`/products/${productId}.js`);
            if (!response.ok) {
            throw new Error('Failed to fetch product data');
            }
            return response.json();
            }
          fetch("/cart.js")
              .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
                return response.json();
              })
            .then(data => {
               data.items.forEach(async item => {
            const productData = await fetchProductData(item.handle);
            try {
                const productData = await fetchProductData(item.handle);
                var ntag = productData.tags;
                resultArray.push(ntag);
              } catch (error) {
                //console.error(`Error fetching product data for product "${item.title}":`, error);
              }
            });
              if(data.total_price == 0)
            {
                 setTimeout(function() { 
                    $('#CartDrawer-Checkout').prop('disabled', true);
                    $.ajax({
                    type: 'POST',
                    url: '/cart/clear.js', // URL to clear the cart
                    dataType: 'json',
                    success: function(cart) {
                    //console.log('Cart cleared successfully');
                       /*$("#mycartdrawer").load(location.href + " #CartDrawer");
                      setTimeout(function() {   
                          $('.cart-drawer:not(.is-empty) .cart-drawer__warnings').css('display','flex'); 
                      }, 1500);*/
                    },
                    error: function(xhr, textStatus, errorThrown) {
                    //console.error('Error clearing cart: ' + textStatus, errorThrown);
                    }
                    });
                   }, 1000);
            }
                setTimeout(function() {
                    var cprice = data.total_price/100;
                    function wordExistsInArray(word, array) {
                    for (var i = 0; i < array.length; i++) {
                    for (var j = 0; j < array[i].length; j++) {
                    if (array[i][j] === word) {
                    return true;
                    }
                    }
                    }
                    return false; // Word not found
                    }
                    
                    var wtf1 = "first";
                    var wtf2 = "second";
                    var wtf3 = "forth";
                    var wtf4 = "fifth";
                    
                    if (wordExistsInArray(wtf1, resultArray) && cprice <= 0) {
                    $('#CartDrawer-Checkout').prop('disabled', true);
                    } else if (wordExistsInArray(wtf2, resultArray) && cprice < 101) {
                    $('#CartDrawer-Checkout').prop('disabled', true);
                    } else {
                    $('#CartDrawer-Checkout').prop('disabled', false);
                    }
                }, 1000);
            })
            .catch(error => {
            //console.error('There was a problem fetching the cart:', error);
            });
          }, 1000);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
     //console.log('change cart');
   setTimeout(function() {
         //console.log('change cart');
          let resultArray = [];
          async function fetchProductData(productId) {
          const response = await fetch(`/products/${productId}.js`);
          if (!response.ok) {
            throw new Error('Failed to fetch product data');
          }
          return response.json();
        }
    fetch("/cart.js")
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
       return response.json();
    })
    .then(data => {
        //console.log(data.total_price);
        var cprice11 = data.total_price/100;
          if(cprice11 < 50)
          {
              $('.gratiscadeau1').trigger('click');
          }
          if(cprice11 > 50 && cprice11 < 100)
          {
              $('.gratiscadeau2').trigger('click');
          }
          if(cprice11 > 100 && cprice11 < 175)
          {
              $('.gratiscadeau3').trigger('click');
          }
          if(cprice11 > 175 && cprice11 < 250)
          {
              $('.gratiscadeau4').trigger('click');
          }
            if(data.total_price == 0)
            {
                 setTimeout(function() { 
                   $('#CartDrawer-Checkout').css('display','none');  
                   }, 1000);
            }
      
            data.items.forEach(async item => {
            const productData = await fetchProductData(item.handle);
            try {
                const productData = await fetchProductData(item.handle);
                var ntag = productData.tags;
                resultArray.push(ntag);
              } catch (error) {
                //console.error(`Error fetching product data for product "${item.title}":`, error);
              }
            });
         setTimeout(function() {
            function wordExistsInArray(word, array) {
              for (var i = 0; i < array.length; i++) {
                for (var j = 0; j < array[i].length; j++) {
                  if (array[i][j] === word) {
                    return true; // Word found
                    }
                  }
              }
              return false; // Word not found
            }
              var wordToFind = "free1";
              var free_pro1 = "first";
              var free_pro2 = "second";
              var cprice1 = data.total_price/100;
              //console.log(cprice1);
              //console.log(resultArray);
                if (wordExistsInArray(free_pro1, resultArray) && (cprice1 > 0 && cprice1 < 101)) {
                    //console.log('no');
                    $('#myPopup').addClass('hide');
                    $('.header__icon.header__icon--cart').trigger('click');
                }
                else  if (wordExistsInArray(free_pro2, resultArray) && (cprice1 >= 101 && cprice1 <= 1000)) {
                   //console.log('no');
                    $('#myPopup').addClass('hide');
                    $('.header__icon.header__icon--cart').trigger('click');
                }
                else
                {
                    //console.log('yes');
                    $('.header__icon.header__icon--cart').trigger('click');
                    $('#cust_popup').trigger('click');
                    $('#myPopup').removeClass('hide');
                }
          }, 1000);
        setTimeout(function() {
          var cprice = data.total_price/100;
              function wordExistsInArray(word, array) {
                for (var i = 0; i < array.length; i++) {
                  for (var j = 0; j < array[i].length; j++) {
                    if (array[i][j] === word) {
                        return true;
                    }
                  }
                }
                  return false; // Word not found
              }

                var wtf1 = "first";
              var wtf2 = "second";
              var wtf3 = "forth";
              var wtf4 = "fifth";
              
              if (wordExistsInArray(wtf1, resultArray) && cprice <= 0) {
                $('#CartDrawer-Checkout').prop('disabled', true);
              } else if (wordExistsInArray(wtf2, resultArray) && cprice < 101) {
                $('#CartDrawer-Checkout').prop('disabled', true);
              } else {
                $('#CartDrawer-Checkout').prop('disabled', false);
              }
        }, 1500);
    })
    .catch(error => {
      //console.error('There was a problem fetching the cart:', error);
    });
}, 1000);
   this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
}

  onCartUpdate() {
    //console.log('update cart');
       let resultArray = [];
       async function fetchProductData(productId) {
        const response = await fetch(`/products/${productId}.js`);
        if (!response.ok) {
          throw new Error('Failed to fetch product data');
        }
        return response.json();
      }
    fetch("/cart.js")
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
      return response.json();
    })
      .then(data => {
        if(data.total_price == 0)
        {
          // setTimeout(function() { $('#CartDrawer-Checkout').css('display','none');  }, 1000);
        }
    data.items.forEach(async item => {
      const productData = await fetchProductData(item.handle);
      try {
       const productData = await fetchProductData(item.handle);
       var ntag = productData.tags;
        resultArray.push(ntag);
      } catch (error) {
        //console.error(`Error fetching product data for product "${item.title}":`, error);
      }
    });
                setTimeout(function() {
                        var cprice = data.total_price/100;
                          function wordExistsInArray(word, array) {
                              for (var i = 0; i < array.length; i++) {
                                for (var j = 0; j < array[i].length; j++) {
                                  if (array[i][j] === word) {
                                    return true; // Word found
                                  }
                              }
                          }
                          return false; // Word not found
                        }
              var wtf1 = "first";
              var wtf2 = "second";
              var wtf3 = "forth";
              var wtf4 = "fifth";
              
              if (wordExistsInArray(wtf1, resultArray) && cprice <= 0) {
                $('#CartDrawer-Checkout').prop('disabled', true);
              } else if (wordExistsInArray(wtf2, resultArray) && cprice < 101) {
                $('#CartDrawer-Checkout').prop('disabled', true);
              } else {
                $('#CartDrawer-Checkout').prop('disabled', false);
              }
                  
              }, 1500);
            })
            .catch(error => {
                //console.error('There was a problem fetching the cart:', error);
            });
     fetch("/cart.js")
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
      return response.json();
    })
      .then(data => {
        if(data.total_price == 0)
        {
        // setTimeout(function() { $('#CartDrawer-Checkout').css('display','none');  }, 1000);
        }
    data.items.forEach(async item => {
      const productData = await fetchProductData(item.handle);
      try {
       const productData = await fetchProductData(item.handle);
       var ntag = productData.tags;
        resultArray.push(ntag);
      } catch (error) {
        //console.error(`Error fetching product data for product "${item.title}":`, error);
      }
    });
            setTimeout(function() {
                function wordExistsInArray(word, array) {
                  for (var i = 0; i < array.length; i++) {
                    for (var j = 0; j < array[i].length; j++) {
                      if (array[i][j] === word) {
                        return true; // Word found
                      }
                    }
                  }
                    return false; // Word not found
                }
                var wordToFind = "free1";
                var free_pro1 = "first";
                var free_pro2 = "second";
               var cprice1 = data.total_price/100;
              //console.log(cprice1);
              //console.log(resultArray);
                if (wordExistsInArray(free_pro1, resultArray) && (cprice1 > 0 && cprice1 < 101)) {
                    //console.log('no');
                    $('#myPopup').addClass('hide');
                    $('.header__icon.header__icon--cart').trigger('click');
                }
                else  if (wordExistsInArray(free_pro2, resultArray) && (cprice1 >= 101 && cprice1 <= 1000)) {
                   //console.log('no');
                    $('#myPopup').addClass('hide');
                    $('.header__icon.header__icon--cart').trigger('click');
                }
                else
                {
                    //console.log('yes');
                    $('.header__icon.header__icon--cart').trigger('click');
                    $('#cust_popup').trigger('click');
                    $('#myPopup').removeClass('hide');
                }
  
               /* if (wordExistsInArray(wordToFind, resultArray)) {
                  //console.log('no');
                  $('#myPopup').addClass('hide');
                  $('.header__icon.header__icon--cart').trigger('click');
                } else {
                  //console.log('yes');
                    $('.header__icon.header__icon--cart').trigger('click');
                    $('#cust_popup').trigger('click');
                    $('#myPopup').removeClass('hide');
                }
                */
            }, 1500);
})
            .catch(error => {
                //console.error('There was a problem fetching the cart:', error);
            });
    
     if (this.tagName === 'CART-DRAWER-ITEMS') {
       fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          //console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          //console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
     fetch("/cart.js").then(function(a) {
          return a.json()
        }).then(function(a) {
          /* $(".upsell").slick({
                  dots: false,
                  arrows: false,
                  speed: 1500,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: true,
                  autoplay: true,
                  autoplaySpeed: 1500,
                  fade: false,
              prevArrow:"<div class='prev'><svg  xmlns='http://www.w3.org/2000/svg' width='8' height='14' id='chevron'><path fill='none'  stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M7 13 1 7l6-6'></path></svg></div>",
      nextArrow:"<div class='next'><svg  xmlns='http://www.w3.org/2000/svg' width='8' height='14' id='chevron'><path fill='none'  stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m1 13 6-6-6-6'></path></svg></div>",

            });
       */
        });
    //$("#cust_popup").trigger("click");
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}


